import { SVGInterface } from "../../interface";

const InProgress = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.04932C5.94668 2.55104 2 6.81459 2 11.9999C2 17.5228 6.47715 21.9999 12 21.9999C14.3542 21.9999 16.5183 21.1865 18.2267 19.8252L16.0859 17.6844C14.9361 18.5123 13.525 18.9999 12 18.9999C8.13401 18.9999 5 15.8659 5 11.9999C5 8.47347 7.60771 5.55606 11 5.07083V2.04932ZM13 5.07083V2.04932C15.057 2.25355 16.9307 3.08114 18.4294 4.34051L16.2966 6.47333C15.3592 5.74352 14.2313 5.24695 13 5.07083ZM18.9291 10.9999C18.766 9.85953 18.328 8.8078 17.6844 7.91399L19.8253 5.77314C20.9913 7.23663 21.7555 9.03459 21.9506 10.9999H18.9291ZM17.5266 16.2966C18.2564 15.3592 18.753 14.2313 18.9291 12.9999H21.9506C21.7464 15.057 20.9188 16.9307 19.6594 18.4295L17.5266 16.2966Z"
      fill={color || "black"}
    />
  </svg>
);

export default InProgress;
